import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetLocations(payload) {
    let query = "";
    if (payload.search) {
      query += `?search=${payload.search}`;
    }
    return Api().get(`/${API_VERSION}/webapp/locations/${query}`);
  },
  GetCities(payload) {
    return Api().get(`/${API_VERSION}/webapp/locations/cities`);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/LocationService.js